"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const StorageItem_1 = __importDefault(require("../utilities/StorageItem"));
class PeakCache {
    constructor(loginHint = new StorageItem_1.default("peakauth:loginHint"), code = new StorageItem_1.default("peakauth:code"), refreshCode = new StorageItem_1.default("peakauth:refreshCode"), provider = new StorageItem_1.default("peakauth:provider"), tokenResponse = new StorageItem_1.default("peakauth:tokenResponse"), isAuthCompleted = new StorageItem_1.default("peakauth:isAuthCompleted")) {
        this.loginHint = loginHint;
        this.code = code;
        this.refreshCode = refreshCode;
        this.provider = provider;
        this.tokenResponse = tokenResponse;
        this.isAuthCompleted = isAuthCompleted;
    }
    remove() {
        this.loginHint.remove();
        this.code.remove();
        this.refreshCode.remove();
        this.provider.remove();
        this.tokenResponse.remove();
        this.isAuthCompleted.remove();
    }
}
exports.default = PeakCache;
